<template>
  <div>
    <div class="background">
      <v-container fluid fill-height>
        <v-row dense justify="center" align="center">
          <v-col cols="12" sm="10" md="6" lg="4">
            <v-card
              style="
                background-color: #fcfcfd;
                border-radius: 10px;
                padding: 30px !important;
              "
            >
              <v-card-title
                class="d-flex align-center justify-center loginImages ma-2"
              >
                <v-img
                  max-height="200"
                  src="@/assets/images/connect/customer/connect-logo.webp"
                  contain
                  height="270"
                />
              </v-card-title>
              <v-card-text
                elevation="0"
                class="f-flex align-center justify-center flex-column"
              >
                <v-form ref="form" class="pa-0" @submit.prevent elevation="0">
                  <v-stepper
                    v-model="step"
                    elevation="0"
                    style="background-color: #fcfcfd"
                  >
                    <v-stepper-items class="pa-0" elevation="0">
                      <v-stepper-content
                        elevation="0"
                        v-if="step === 1"
                        step="1"
                        class="pa-0 d-flex flex-column"
                      >
                        <div>
                          <custom-input
                            required
                            v-model="credentials.email"
                            ref="emailInput"
                            label="Login"
                            placeholder="Email"
                            hint="ex: email@domain.com"
                            :customRule="rules.email"
                            :currentValue="credentials.email"
                            @keydown.enter="nextStep(2)"
                          ></custom-input>
                        </div>
                        <div class="d-flex align-center justify-start">
                          <v-checkbox
                            small
                            v-model="rememberMe"
                            label="Lembrar email"
                          ></v-checkbox>
                        </div>
                        <div class="d-flex flex-column fill-width">
                          <v-btn
                            color="#B51F57"
                            class="white--text fill-width"
                            x-large
                            @click="nextStep(2)"
                          >
                            Avançar
                          </v-btn>
                        </div>
                      </v-stepper-content>

                      <v-stepper-content
                        step="2"
                        class="pa-0 d-flex flex-column"
                        elevation="0"
                      >
                        <custom-input
                          v-if="step === 2"
                          required
                          v-model="credentials.password"
                          class="mt-4"
                          label="Senha"
                          placeholder="Senha"
                          :errorMessage="errorMessage"
                          :type="showPassword ? 'text' : 'password'"
                          :customRule="rules.password"
                          :appendIcon="
                            showPassword ? 'mdi-eye' : 'mdi-eye-closed'
                          "
                          @iconClick="showPassword = !showPassword"
                          @keydown.enter="submitForm"
                        ></custom-input>
                        <div
                          class="d-flex flex-column fill-width"
                          v-if="step === 2"
                        >
                          <v-btn
                            color="#B51F57"
                            class="white--text fill-width"
                            x-large
                            :loading="loadingLogin"
                            @click="submitForm"
                          >
                            Acessar
                          </v-btn>
                          <a
                            class="mt-1 d-flex align-center justify-end"
                            @click="nextStep('recover')"
                            >Esqueceu sua senha?</a
                          >
                        </div>
                      </v-stepper-content>

                      <v-stepper-content
                        elevation="0"
                        v-if="step === 3"
                        step="3"
                        class="d-flex flex-column"
                      >
                        <custom-input
                          v-if="!displayOtp"
                          required
                          v-model="credentials.email"
                          :currentValue="credentials.email"
                          label="Recuperar senha"
                          placeholder="Email"
                          :customRule="rules.email"
                          :errorMessage="errorMessage"
                        ></custom-input>

                        <div v-else>
                          <span
                            >Enviamos no seu e-mail um código para recuperar sua
                            senha, digite-a abaixo:</span
                          >
                          <v-otp-input
                            plain
                            v-model="otpValue"
                            length="6"
                            type="password"
                            :disabled="loadingOtp"
                            @finish="onFinishOtp"
                          ></v-otp-input>
                          <v-overlay absolute :value="loadingOtp">
                            <v-progress-circular
                              indeterminate
                              color="primary"
                            ></v-progress-circular>
                          </v-overlay>
                        </div>
                        <div
                          class="d-flex flex-column fill-width align-center justify-center"
                          v-if="invalidOtp"
                        >
                          <span style="color: #a90e61">{{ errorMessage }}</span>
                        </div>
                        <div
                          class="d-flex flex-column fill-width"
                          v-if="!displayOtp"
                        >
                          <v-btn
                            color="#B51F57"
                            class="white--text fill-width"
                            x-large
                            @click="recoverPassword()"
                          >
                            Recuperar senha
                          </v-btn>
                        </div>
                        <div
                          class="d-flex align-center justify-center flex-column"
                          v-if="displayOtp"
                        >
                          <span>Não recebeu o código ?</span>
                          <a @click="recoverPassword()">clique aqui</a>
                        </div>
                      </v-stepper-content>
                      <v-stepper-content
                        elevation="0"
                        v-if="step === 4"
                        step="4"
                        class="d-flex flex-column"
                      >
                        <custom-input
                          v-if="step === 4"
                          required
                          v-model="newPassword"
                          label="Nova senha"
                          placeholder="Digite a nova senha"
                          :type="showPassword ? 'text' : 'password'"
                          :customRule="rules.password"
                          :currentValue="newPassword"
                          :errorMessage="errorMessage"
                          class="mt-4"
                          :appendIcon="
                            showPassword ? 'mdi-eye' : 'mdi-eye-closed'
                          "
                          @iconClick="showPassword = !showPassword"
                        ></custom-input>
                        <div
                          class="d-flex flex-column fill-width"
                          v-if="step === 4"
                        >
                          <v-btn
                            color="#B51F57"
                            class="white--text fill-width"
                            x-large
                            @click="submitPasswordChange"
                          >
                            Redefinir
                          </v-btn>
                        </div>
                      </v-stepper-content>
                      <v-stepper-content
                        elevation="0"
                        v-if="step === 5"
                        step="5"
                        class="d-flex flex-column"
                      >
                        <div
                          class="d-flex align-center justify-center primary"
                          style="color: #a90e61; background-clip: text"
                        >
                          <h1>Senha cadastrada</h1>
                        </div>
                        <div class="d-flex align-center justify-center mt-2">
                          <span>Agora você pode fazer login na sua conta.</span>
                        </div>
                        <div
                          class="d-flex flex-column fill-width mt-2"
                          v-if="step === 5"
                        >
                          <v-btn
                            color="#B51F57"
                            class="white--text fill-width"
                            x-large
                            @click="returnToLogin"
                          >
                            Tela de login
                          </v-btn>
                        </div>
                      </v-stepper-content>
                    </v-stepper-items>
                  </v-stepper>
                </v-form>
                <div class="pt-2 d-flex align-center justify-start">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon @click="returnToHome" v-on="on" v-bind="attrs"
                        ><v-icon>mdi-arrow-left</v-icon></v-btn
                      >
                    </template>
                    <span>Retornar</span>
                  </v-tooltip>
                </div>
                <div
                  class="mt-2 d-flex align-center justify-center flex-column"
                >
                  <span
                    >Ainda não tem uma conta ?
                    <a @click="nextStep('new')">Clique aqui.</a></span
                  >
                </div>
              </v-card-text>
              <v-card-actions
                class="d-flex align-center justify-center flex-column"
              >
                <div>
                  <CopyRight />
                </div>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import CopyRight from "@/components/CopyRight.vue";
import api from "@/shared/pitchCustomerApi";

export default {
  name: "CustomerLogin",
  components: {
    CopyRight,
  },
  data() {
    return {
      loading: false,
      loadingLogin: false,
      step: 1,
      showPassword: false,
      formValid: false,
      displayOtp: false,
      rememberMe: false,
      newPassword: "",
      otpValue: "",
      invalidOtp: false,
      loadingOtp: false,
      errorMessage: "",
      tempPassToken: "",
      credentials: {
        email: "",
        password: "",
      },
      rules: {
        email: [
          (v) => !!v || "Campo obrigatório.",
          (v) => /.+@.+\..+/.test(v) || "Email inválido.",
        ],
        password: [
          (v) => !!v || "Campo obrigatório.",
          (v) =>
            /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%*#¢+§])[A-Za-z\d@$!%*#?$§-]{8,}$/.test(
              v
            ) ||
            "Senha deve ter pelo menos 8 caracteres, incluindo pelo menos uma letra maiuscula, um número e um caractere especial",
        ],
      },
    };
  },
  async created() {
    const email = localStorage.getItem("email");
    if (email) {
      this.credentials.email = email;
      this.rememberMe = true;
    }
  },
  methods: {
    ...mapActions(["setSignIn"]),
    nextStep(step) {
      if (step === "recover") this.step = 3;
      else if (step === "new") this.$router.push({ path: "/registro-aluno" });
      else {
        if (this.$refs.form.validate()) {
          if (this.step === 2 && this.rememberMe && this.credentials.email)
            localStorage.setItem("email", this.credentials.email);
          this.step = step;
        }
      }
    },
    submitForm() {
      if (this.$refs.form.validate()) {
        this.loadingLogin = true;
        api
          .signIn(this.credentials)
          .then((res) => {
            const name = res.data.user.name;
            this.setSignIn({
              initials: `${name.split(" ")[0].substring(0, 1)} ${name
                .split(" ")[1]
                .substring(0, 1)}`,
              user: {
                name: res.data.user.name,
                avatar: res.data.user.avatar,
                accountType: res.data.user.accountType,
                groups: res.data.user.groups,
                preference: res.data.user.preference,
                status: res.data.user.status,
                notificationsCount: res.data.notifications,
              },
              token: res.data.auth,
              refreshToken: res.data.refreshToken,
              module: "aluno",
            });
            this.loadingLogin = false;
            this.$router.push({
              name: "Dashboard",
            });
          })
          .catch((err) => {
            console.log(err);
            this.loadingLogin = false;
            this.errorMessage = Array.isArray(err.response.data.message)
              ? err.response.data.message[0]
              : err.response.data.message;
          });
      }
    },
    returnToHome() {
      localStorage.removeItem("module");
      this.$emit("selected", "ModuleSelection");
    },
    recoverPassword() {
      if (this.$refs.form.validate()) {
        api
          .requestRecoverPassword(this.credentials.email)
          .then((res) => {
            this.displayOtp = true;
            this.tempPassToken = res.data.token;
          })
          .catch((err) => {
            this.errorMessage = Array.isArray(err.response.data.message)
              ? err.response.data.message[0]
              : err.response.data.message;
          });
      }
    },
    onFinishOtp() {
      this.loadingOtp = true;
      api
        .validateOtp(this.otpValue)
        .then((res) => {
          if (res.data.result) {
            this.nextStep(4);
          } else {
            this.errorMessage = "Código OTP inválido";
            this.invalidOtp = true;
          }
        })
        .catch((err) => {
          this.invalidOtp = true;
          this.errorMessage = err.response.data.message;
        })
        .finally(() => {
          this.loadingOtp = false;
        });
    },
    submitPasswordChange() {
      if (this.$refs.form.validate()) {
        api
          .updatePassword({
            otp: this.otpValue,
            token: this.tempPassToken,
            password: this.newPassword,
          })
          .then(() => {
            this.nextStep(5);
          })
          .catch((err) => {
            this.errorMessage = Array.isArray(err.response.data.message)
              ? err.response.data.message[0]
              : err.response.data.message;
          });
      }
    },
    returnToLogin() {
      this.errorMessage = "";
      this.nextStep(1);
    },
  },
  watch: {
    rememberMe(value) {
      if (value) localStorage.setItem("email", this.credentials.email);
      else localStorage.removeItem("email");
    },
  },
};
</script>

<style scoped>
.background {
  background-image: url("../../../assets/images/connect/customer/background-min.webp");
  height: 100vh;
  width: 100vw;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  min-height: 100vh;
  position: relative;
  top: 0;
  left: 0;
}
</style>
